import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { Producto, ProductoEstado } from '../../../interfaces/producto';
import { FormControl, Validators } from '@angular/forms';
import { ProductoService } from '../../../providers/producto.service';
import { Caracteristica } from '../../../interfaces/caracteristica';
import { ListarCaracteristicasComponent } from '../caracteristicas/listar-caracteristicas/listar-caracteristicas.component';
import { TipoProductoService } from '../../../providers/tipo-producto.service';
import { TipoProducto, TipoProductoCategoria } from '../../../interfaces/tipo-producto';
import * as moment from 'moment';
import { MatCheckboxChange, MatCheckbox } from '@angular/material';
import { CaracteristicaValor } from '../../../interfaces/valor-caracteristica';
import { TipoProductoCategoriaService } from '../../../providers/tipo-producto-categoria.service';

@Component({
  selector: 'app-producto',
  templateUrl: './producto.component.html',
  styleUrls: ['./producto.component.scss']
})
export class ProductoComponent implements OnInit {
  @Input() IdProducto?: number | string;
  producto: Producto = new Producto();
  estadosProducto: ProductoEstado[] = [];
  cargandoEstados: boolean = false;
  tiposProducto: TipoProducto[] = [];
  categorias: TipoProductoCategoria[]=[];
  cargandoTipos: boolean = false;
  categoriasCargando: boolean = false;
  @Output() onProductoInput = new EventEmitter(); // datos del formulario cambian
  @Output() formState = new EventEmitter(); // emite el estado del formulario
  public tipoOferta: string;
  oferta: string = '';

  // listado de caracteristicas
  @ViewChild(ListarCaracteristicasComponent) listadoCaracteristicas: ListarCaracteristicasComponent;

  // checkbox descripción custom
  @ViewChild('descripcionCustom') descripcionCustom: MatCheckbox;

  descripcionFormControl = new FormControl('', [
    Validators.required,
    Validators.maxLength(500)
  ]);
  stockFormControl = new FormControl('', [
    Validators.min(0),
    Validators.max(99999999999)
  ]);
  tipoProductoFormControl = new FormControl('', [
    Validators.required
  ]);
  tipoCategoriaFormControl = new FormControl('', [
    Validators.required
  ]);

  constructor(
    private productoService: ProductoService,
    private tipoProductoService: TipoProductoService,
    private categoriasService: TipoProductoCategoriaService
  ) { }

  ngOnInit() {
    this.tipoOferta = this.productoService.getTipoOferta();
    this.oferta = this.tipoOferta == '2' ? 'servicio' : 'producto';
    if (Object.keys(this.producto.tipo).length) { // si el campo esta previamente seteado
      this.tipoProductoFormControl.setValue(this.producto.tipo); // setar el valor del campo en el controlador del input
    }

    if (this.IdProducto != null) { // si recibo un id solicitar los datos
      this.formState.emit({ cargando: true });
      this.productoService.getProductos(
        {
          page: null,
          pageSize: null
        },
        {
          sort: null,
          order: null
        },
        {
          IdProducto: this.IdProducto
        }
      ).subscribe(
        respuesta => {
          if (respuesta.estado == 1 && respuesta.data) {
            var producto = respuesta.data.productos[0];
            if (producto) {
              this.producto = new Producto(
                producto.IdProducto,
                producto.fechaAlta,
                producto.descripcion,
                producto.stock,
                producto.observaciones,
                !!+producto.web,
                !!+producto.destacado,
                producto.importe,
                !!+producto.importeMostrar,
                <ProductoEstado>{
                  IdEstado: producto.estado.id,
                  descripcion: producto.estado.desc
                },
                <TipoProducto>{
                  id: producto.tipo.id,
                  descripcion: producto.tipo.desc
                },
                <Caracteristica[]>[], // blanquear caracteristicas
                !!+producto.descripcionCustom,
                !!+producto.especial,
                producto.ProductoCUT,
              );

              // guardar los valores de las características seleccionadas para este producto
              if (producto.caracteristicas) {
                var index = producto.caracteristicas.length;
                while (index--) {
                  var caracteristicaAsignada = producto.caracteristicas[index];
                  this.producto.caracteristicas.push(new Caracteristica(
                    caracteristicaAsignada.IdCarac,
                    caracteristicaAsignada.caracDesc,
                    null,
                    new CaracteristicaValor(
                      caracteristicaAsignada.IdValor,
                      caracteristicaAsignada.valor
                    ),
                    null,
                    null,
                    null
                  ));
                }
              }

              // setar el valor del tipo de producto
              this.tipoProductoFormControl.setValue(this.producto.tipo);

              this.formState.emit({ // datos encontrados
                estado: 1,
                mensaje: respuesta.mensaje,
                cargando: false
              });
            } else {
              this.formState.emit({ // error al buscar datos
                estado: 3,
                mensaje: 'No se encontraron los datos buscados',
                cargando: false
              });
            }
          }
        },
        error => {
          this.formState.emit({ // error con el servidor
            estado: 2,
            mensaje: error,
            cargando: false
          });
        }
      );
    }

    this.traerTiposProducto();
    this.traerCategorias();
    this.traerEstados();
  }

  onInput(): void { // cuando cambia un dato emitimos un evento
    this.onProductoInput.emit();
  }

  traerEstados(): void {
    this.estadosProducto = [];
    this.cargandoEstados = true;
    this.productoService.getEstadosProducto().subscribe(
      estadosProductoArray => {
        if (estadosProductoArray && estadosProductoArray.length > 0) {
          this.estadosProducto = estadosProductoArray;
        } else {
          this.formState.emit({ // error al buscar datos
            estado: 3,
            mensaje: 'Los estados del '+this.oferta+' son desconocidos'
          });
        }

        this.cargandoEstados = false;
      },
      error => {
        this.cargandoEstados = false;

        this.formState.emit({ // error al buscar datos
          estado: 2,
          mensaje: error
        });
      }
    );
  }

  traerTiposProducto(): void {
    this.tiposProducto = [];
    this.cargandoTipos = true;
    this.tipoProductoService.getTiposProducto(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'descripcion',
        order: 'asc'
      },
      {
        generico: '',
        tipo: this.tipoOferta
      }
    ).subscribe(
      (respuesta) => {
        this.tiposProducto = <TipoProducto[]>[];
        if (respuesta.data.tiposProducto.length > 0) {
          respuesta.data.tiposProducto.forEach(tipoProducto => {
            this.tiposProducto.push(<TipoProducto>{
              id: tipoProducto.IdTipoProducto,
              descripcion: tipoProducto.TipoProductoDesc
            });
          });
        } else {
          this.formState.emit({ // error al buscar datos
            estado: 3,
            mensaje: 'Los tipos de '+this.oferta+' son desconocidos'
          });
        }

        this.cargandoTipos = false;
      },
      error => {
        this.cargandoTipos = false;

        this.formState.emit({ // error al buscar datos
          estado: 2,
          mensaje: error
        });
      }
    );
  }

  traerCategorias(): void {
    this.categorias = [];
    this.categoriasCargando = true;
    this.categoriasService.getTipoProductoCategoria(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'descripcion',
        order: 'asc'
      },
      {
        generico: '',
        tipo: this.tipoOferta
      }
    ).subscribe(
      (respuesta) => {
        this.categorias = <TipoProductoCategoria[]>[];
        if (respuesta.data.categorias.length > 0) {
          respuesta.data.categorias.forEach(categoria => {
            this.categorias.push(<TipoProductoCategoria>{
              IdCategoria: categoria.IdCategoria,
              descripcion: categoria.descripcion
            });
          });
        } else {
          this.formState.emit({ // error al buscar datos
            estado: 3,
            mensaje: 'Los tipos de '+this.oferta+' son desconocidos'
          });
        }

        this.categoriasCargando = false;
      },
      error => {
        this.categoriasCargando = false;

        this.formState.emit({ // error al buscar datos
          estado: 2,
          mensaje: error
        });
      }
    );
  }

  compararTipoProducto(tipo1: any, tipo2: any): boolean | null { // le dice al select como comparar
    if (tipo1 && tipo2) {
      return tipo1.id == tipo2.id;
    }

    return false;
  }

  onTipoProductoChange() {
    this.completarDescripcion();
  }

  onCaracteristicasChange() {
    this.completarDescripcion();
  }

  onDescripcionCustomChange(event: MatCheckboxChange) {
    // si descripción custom activada
    if (event.checked) {
      // vaciar la descripción seleccionada
      //this.producto.descripcion = "";
      //this.descripcionFormControl.setValue(null);
      this.descripcionFormControl.markAsTouched();
    } else {
      // autocompletar la descripción
      this.completarDescripcion();
    }
  }

  /**
   * La descripción del producto es su tipo más su potencia
   */
  completarDescripcion() {
    // si la descrión no es custom, debemos autocompletarla
    if (!this.descripcionCustom.checked) {
      // obtener la descripción de las caracteristicas si tienen un valor seleccionado
      this.producto.caracteristicas.sort((a, b) => {
        if (a.ordenImpresion < b.ordenImpresion)
          return -1;
        if (a.ordenImpresion > b.ordenImpresion)
          return 1;
        return 0;
      });
      let caracteristicasString = this.producto.caracteristicas.map((caracteristica: Caracteristica) => {
        if (caracteristica.seleccionado) {
          switch (caracteristica.tipoCaracteristica.descripcion) {
            case "FECHA":
              return moment(caracteristica.seleccionado.descripcion, "YYYY-MM-DD").format("DD/MM/YYYY");
            default:
              return caracteristica.seleccionado.descripcion;
          }
        }

        return null;
      }).filter(valor => (valor) ? valor.length > 0 : false).join(' | ');

      this.producto.descripcion = '';
      if (this.producto.tipo.descripcion) {
        this.producto.descripcion += this.producto.tipo.descripcion;
      }
      if (caracteristicasString.length > 0) {
        this.producto.descripcion += ' | ' + caracteristicasString;
      }
    }
  }

  getProducto(): Producto {
    // revisar las validaciones
    if (this.descripcionFormControl.hasError('required') ||
      this.descripcionFormControl.hasError('maxlength') ||
      this.stockFormControl.hasError('min') ||
      this.stockFormControl.hasError('max') ||
      // this.estadoFormControl.hasError('required') ||
      this.tipoProductoFormControl.hasError('required')) {
      // marcar inputs como usados para mostrar el error si es necesario
      this.descripcionFormControl.markAsTouched();
      this.stockFormControl.markAsTouched();
      // this.estadoFormControl.markAsTouched();
      this.tipoProductoFormControl.markAsTouched();

      throw "Datos incorrectos";
    }

    return this.producto;
  }

  validateFormat(event) {
    let key;
    if (event.type === 'paste') {
      key = event.clipboardData.getData('text/plain');
    } else {
      key = event.keyCode;
      key = String.fromCharCode(key);
    }
    const regex = /[0-9]|\./;
    if (!regex.test(key)) {
      event.returnValue = false;
      if (event.preventDefault) {
        event.preventDefault();
      }
    }
  }
}
